"use strict";

exports.__esModule = true;
exports["default"] = exports.CloseIcon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _styledSystem = require("styled-system");

var _panelContent = _interopRequireDefault(require("../panel-content"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _buttonsContainer = _interopRequireDefault(require("../buttons-container"));

var _elements = require("../glyphs/elements");

var _cta = _interopRequireDefault(require("../cta"));

var _utils = require("../../utils");

var _custom = _interopRequireDefault(require("../../primitives/custom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// eslint-disable-next-line import/max-dependencies
var ItemContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "growler__ItemContainer",
  componentId: "sc-1plb241-0"
})(["position:relative;flex:0 0 auto;"]);
var ItemBack = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "growler__ItemBack",
  componentId: "sc-1plb241-1"
})(["position:relative;box-shadow:0 2px 10px 0 ", ",0 20px 20px -12px ", ";"], function (props) {
  return (0, _styles.themeTransparentize)(0.92, "background-dark")(props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.76, "background-dark")(props);
});
var CloseIcon = (0, _styledComponents["default"])(_elements.NavClose).withConfig({
  displayName: "growler__CloseIcon",
  componentId: "sc-1plb241-2"
})(["cursor:pointer;", ";", ";"], (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.height, _styledSystem.width), _custom["default"]);
exports.CloseIcon = CloseIcon;
var CloseButton = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "growler__CloseButton",
  componentId: "sc-1plb241-3"
})(["position:absolute;right:24px;top:24px;"]);
var propTypes = {
  /** Array of objects to build CTAs  */
  buttons: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    onClick: _propTypes.func,
    title: _propTypes.node,
    url: _propTypes.string
  })),

  /** Title text usually a text, but can be a React component  */
  description: _propTypes.node,

  /** Id to send with close click handler  */
  id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),

  /** Bool for if it is the first Growler shown  */
  isFirst: _propTypes.bool,

  /** Close click handler  */
  onCloseClick: _propTypes.func,

  /** Description text usually a text, but can be a React component  */
  title: _propTypes.node
};
var descriptionFont = {
  color: "text-light",
  fontSize: 2,
  fontWeight: 1,
  letterSpacing: "0.5px",
  lineHeight: 2,
  textAlign: "left"
};
var titleFont = {
  color: "text-light",
  fontSize: 3,
  fontWeight: 2,
  letterSpacing: "0.5px",
  lineHeight: 1,
  mb: 1,
  pr: 3,
  textAlign: "left"
};

var Growler = function Growler(_ref) {
  var id = _ref.id,
      isFirst = _ref.isFirst,
      buttons = _ref.buttons,
      description = _ref.description,
      onCloseClick = _ref.onCloseClick,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(ItemContainer, {
    "data-test-id": "modules-growler",
    mb: isFirst ? [null, 3] : 0,
    mt: ["1px", 2],
    px: [null, 3],
    width: "1"
  }, /*#__PURE__*/_react["default"].createElement(ItemBack, {
    backgroundColor: "blue",
    borderRadius: [null, "8px"],
    flexDirection: "column",
    p: 3,
    width: [1, "350px"]
  }, /*#__PURE__*/_react["default"].createElement(CloseButton, {
    onClick: function onClick(event) {
      return onCloseClick(event, id);
    }
  }, /*#__PURE__*/_react["default"].createElement(CloseIcon, {
    fill: "white",
    height: 16,
    width: 16
  })), /*#__PURE__*/_react["default"].createElement(_panelContent["default"], {
    alignItems: "flex-start",
    description: description,
    descriptionFont: descriptionFont,
    justifyContent: "flex-start",
    title: title,
    titleFont: titleFont
  }), buttons && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_buttonsContainer["default"], {
    display: ["none", "flex"],
    mt: 2
  }, (0, _utils.mapIndexed)(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_cta["default"], {
      key: item.id,
      darkUi: true,
      fontSize: 1,
      glyphRight: /*#__PURE__*/_react["default"].createElement(_elements.NavCaretRight, null),
      iconSize: 12,
      letterSpacing: "0.5px",
      mb: 0,
      mr: index !== buttons.length - 1 ? 3 : null,
      onClick: item.onClick,
      url: item.url,
      version: "link"
    }, item.title);
  }, buttons)), /*#__PURE__*/_react["default"].createElement(_buttonsContainer["default"], {
    display: ["flex", "none"],
    mt: 2
  }, (0, _utils.mapIndexed)(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_cta["default"], {
      key: "mobile" + item.id,
      darkUi: true,
      display: [null, "none"],
      fontSize: 1,
      iconSize: 12,
      mr: index !== buttons.length - 1 ? 3 : null,
      onClick: item.onClick,
      size: "small",
      url: item.url,
      version: "tertiary"
    }, item.title);
  }, buttons)))));
};

Growler.propTypes = propTypes;
Growler.displayName = "Modules.Growler";
var _default = Growler;
exports["default"] = _default;